<div class="container-fluid form-group">
  <form [formGroup]="schemaForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-sm-2 col-md-4 schema-section">
        <label for="event-product" class="event-product-label">Product</label>
        <bento-combobox class="form-control-event-product" id="eventproduct" formControlName="eventProduct"
          [itemsObservable]="dataProductsEmitter" [options]="comboboxOptions">
        </bento-combobox>
      </div>
      <div class="col-sm-2 col-md-4 schema-section">
        <label for="eventChannel" class="event-channel-label">Channel</label>
        <bento-combobox class="form-control-event-channel" id="eventChannel" formControlName="eventChannel"
          [itemsObservable]="dataChannelsEmitter" [options]="comboboxOptions">
        </bento-combobox>
      </div>
      <div class="col-sm-2 col-md-4 schema-section">
        <label for="eventSchema" class="event-schema-label">Schema <span class="text-danger">*</span></label>
        <bento-combobox class="form-control-event-schema" id="eventSchema" formControlName="eventSchema"
          [itemsObservable]="dataSchemasEmitter" [options]="comboboxSchemaOptions"
          (ngModelChange)="changeSchema($event)">
        </bento-combobox>
      </div>
    </div>
    <div class="bento-tabset tabs-top">
      <ul class="nav nav-pills" ngbNav #nav="ngbNav" type="pills" [orientation]="'horizontal'" ngPreserveWhitespaces>
        <li ngbNavItem="a">
          <a ngbNavLink>Request Payload <span class="text-danger">*</span></a>
          <ng-template ngbNavContent>
            <textarea class="form-control" formControlName="requestPayload" id="form-validation-comments"
              rows="15"></textarea>
          </ng-template>
        </li>
        <li ngbNavItem="b">
          <a ngbNavLink>Schema Specification</a>
          <ng-template ngbNavContent>
            <textarea class="form-control" formControlName="schemaSpecification" rows="15" readonly></textarea>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="tab-content"></div>
    </div>
    <br />
    <label class="registration-label" for="registrationSelect">Event Registrations <span
        class="text-danger">*</span>&nbsp;</label>
    <div class="info-icon">
      <i class="bento-icon-info" ngbPopover="Please select endpoint to check response" placement="top-left"
        popoverTitle="Event Registrations"></i>
    </div>

    <div class="form-container">
      <bento-combobox class="form-control-event-Registration" id="event-registration"
        formControlName="eventRegistration" [itemsObservable]="dataEventsEmitter" [options]="comboboxOptions">
      </bento-combobox>
      <button type="submit" class="gfrBtn" id="send-button">Send</button>
    </div>
  </form>
</div>

<router-outlet></router-outlet>